import { render } from "./tickets-recurring.vue?vue&type=template&id=5f20f8df"
import script from "./tickets-recurring.vue?vue&type=script&lang=js"
export * from "./tickets-recurring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__